export default {output:'SALIDA'};